import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscriber } from 'rxjs';

@Component({
  selector: 'app-available-status',
  templateUrl: './available-status.component.html',
  styleUrls: ['./available-status.component.scss']
})
export class AvailableStatusComponent implements OnInit {
  availForm: FormGroup;
  constructor(public umsService: UmsService, private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router, private httpClient: HttpClient,
    private dialogRef2: MatDialogRef<AvailableStatusComponent>,
    private route: ActivatedRoute, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService, private dialog: MatDialog,) { }
  showAddReason: boolean
  formattedFromDate
  formattedToDate
  formattedFromDate2
  formattedToDate2
  ShowAvail
  ShowExaminer
  dialogRef: MatDialogRef<any>;
  availableMessage
  assiMessage
  ngOnInit(): void {
    this.data.selected;
    this.availForm = this.fb.group({
      reqtyp: new FormControl(''),
      Availability: new FormControl('', Validators.required),
      dateRange: new FormControl(''),
      comments: new FormControl(''),
      Reason: new FormControl(''),
      AcceptStatus: new FormControl(''),
    });
console.log('this.data',this.data);

    if (this.data.type === 'Availability') {
      this.ShowAvail = true;
      this.ShowExaminer = false;
    } else {
      this.ShowAvail = false;
      this.ShowExaminer = true;
    }
    this.availForm.controls['reqtyp'].setValue(this.data.selected.AssignedAs);
    this.formatDate()
  }


  formatDate() {
    const fromDate = this.data.selected.FromDate; // your date string
    const date = new Date(fromDate);
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-indexed
    const year = date.getFullYear();
    this.formattedFromDate = `${day}-${month}-${year}`;
    this.formattedFromDate2 = `${year}-${month}-${day}`;
    const toDate = this.data.selected.ToDate; // your date string
    const date2 = new Date(toDate);
    const day2 = String(date2.getDate()).padStart(2, '0'); // Ensure 2 digits
    const tomonth = String(date2.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-indexed
    const toyear = date2.getFullYear();
    this.formattedToDate = `${day2}-${tomonth}-${toyear}`;
    this.formattedToDate2 = `${toyear}-${tomonth}-${day2}`;

    const dateRange = `${this.formattedFromDate} - ${this.formattedToDate}`;
    this.availForm.controls['dateRange'].setValue(dateRange);
  }
  availableStatus(value) {
    if (value == 0) {
      this.showAddReason = true
    } else {
      this.showAddReason = false
    }

  }
  update() {
    if (this.availForm.invalid) {
      this.availForm.get('Availability').markAsTouched();


    } else {
      this.updateStatus();
    }
  }

  updateStatus() {
    if (this.availForm.value.Availability == 1) {
      this.availForm.get('Reason').markAsTouched();
    } else {
      this.availForm.controls['Reason'].clearValidators();
    }
    let payload = {};
    payload["IEATechId"] = this.data.selected.IEATechId,
      payload["CgCode"] = this.data.selected.CgCode,
      payload["CoCode"] = this.data.selected.CoCode,
      payload["SubId"] = this.data.selected.SubId,
      payload["ExternalTechId"] = this.data.selected.ExternalTechId,
      payload["InternalTechId"] = this.data.selected.InternalTechId,
      payload["EmId"] = this.data.selected.EmId,
      payload["Notes"] = this.data.selected.Notes,
      payload["SessionId"] = this.data.selected.SessionId,
      payload["Availability"] = this.availForm.value.Availability,
      payload["Reason"] = this.availForm.value.Reason,
      payload["FromDate"] = this.formattedFromDate2,
      payload["ToDate"] = this.formattedToDate2

    if (this.availForm.value.Availability == 1) {
      this.availableMessage = "Availability Request Accepted"
    }
    else {
      this.availableMessage = "Availability Request Rejected"
    }
    this.umsService.updateTeacherAvailability(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = this.availableMessage
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef2.close()
          this.ngOnInit();
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }


  requestAcceptenceClick(value) {



  }

  updateTeacherAssignment() {
    let payload = {};
    payload["IETechId"] = this.data.selected.IETechId;
    payload["EmId"] = this.data.selected.EmId;
    payload["SubId"] = this.data.selected.SubId;
    payload["TechId"] = this.data.selected.TechId;
    payload["SessionId"] = this.data.selected.SessionId;
    payload["AcceptStatus"] = this.availForm.value.AcceptStatus;

    if (this.availForm.value.AcceptStatus == 1) {
      this.assiMessage = "Assignement Request Accepted"
    }
    else {
      this.assiMessage = "Assignement Request Rejected"
    }

    this.umsService.updateTeacherAssignemt(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = this.assiMessage
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }
}
